export type SftpIntegrationUser = {
  username: string;
  ssh_keys: SftpPubKeyData[];
};

export type SftpPubKeyData = {
  key_id: string;
};

export type SftpPubKeyRequest = {
  key: string;
};

export type AppendSftpKeyResponse = {
  key_id: string;
  username: string;
};

export type VenuesWithSftpConfig = {
  venue_id: string;
  item_update_csv_enabled: boolean;
  item_update_json_enabled: boolean;
  inventory_update_csv_enabled: boolean;
  inventory_update_json_enabled: boolean;
};

export type VenuesWithSftpConfigResponse = {
  data: VenuesWithSftpConfig[];
};

export enum FileBasedIntegrationType {
  INVENTORY_UPDATE_CSV = 'INVENTORY_UPDATE_CSV',
  INVENTORY_UPDATE_JSON = 'INVENTORY_UPDATE_JSON',
  ITEM_UPDATE_CSV = 'ITEM_UPDATE_CSV',
  ITEM_UPDATE_JSON = 'ITEM_UPDATE_JSON',
}

export type SetEnabledSftpPosConfigVenue = {
  venue_id: string;
  type: FileBasedIntegrationType;
  enabled: boolean;
};
